import { render } from "./BaseMoney.vue?vue&type=template&id=679a8a15"
import script from "./BaseMoney.vue?vue&type=script&lang=js"
export * from "./BaseMoney.vue?vue&type=script&lang=js"

import "./BaseMoney.vue?vue&type=style&index=0&id=679a8a15&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__